export default "__VITE_ASSET__2576bffb__"